<script>
  import { onMount } from 'svelte';
  import Alert from '../components/Alert.svelte';
  import Button from '../components/Button.svelte';
  import { getSources, getDisclosure } from '../lib/api.js';
  import { disclosureDraft, loadDraft } from '../lib/disclosureDraft.svelte.js';
  import { go } from '../lib/nav.svelte.js';

  let error = $state(null);
  let sources = $state([]);
  let sourceId = $state(null);

  async function openSource(id = sourceId) {
    if (!id) return;
    if (disclosureDraft.dirty && disclosureDraft.sourceId !== id
      && !window.confirm(`Discard the unsaved changes for ${disclosureDraft.sourceId}?`)) return;
    try { loadDraft(await getDisclosure(id)); go('disclosure/label', { source: id }); }
    catch (e) { error = e.message; }
  }

  onMount(async () => {
    try {
      ({ sources } = await getSources());
      if (!sources.length) {
        error = 'No sources are configured.';
        return;
      }
      if (sources.length === 1 && !disclosureDraft.loaded) { sourceId = sources[0].id; await openSource(); }
    } catch (e) {
      error = e.message;
    }
  });
</script>

{#if error}
  <Alert title="Could not open your sources" variant="danger">{error}</Alert>
{:else if sources.length > 1 || disclosureDraft.loaded}
  <h1 class="wf2-title wf2-title-level-1">Sources</h1>
  <p class="wf2-subtitle">Choose which source mapping to assess and label.</p>
  {#if disclosureDraft.loaded}
    <Alert title="Draft open" variant={disclosureDraft.dirty ? 'warning' : 'info'}>
      <p>{disclosureDraft.sourceId}{disclosureDraft.dirty ? ' has unsaved changes.' : ' is open in this tab.'}</p>
      <Button onclick={() => openSource(disclosureDraft.sourceId)}>Continue draft</Button>
    </Alert>
  {/if}
  <div class="wf2-tablewrap"><table class="wf2-table"><thead><tr><th>Source</th><th>ID</th><th>Rows</th><th>Status</th><th></th></tr></thead><tbody>
    {#each sources as source}<tr><td>{source.label}</td><td class="mono">{source.id}</td><td>{source.rowsInSource}</td><td>{source.status}</td><td><Button variant="ghost" onclick={() => openSource(source.id)}>Assess and label</Button></td></tr>{/each}
  </tbody></table></div>
{:else}
  <div class="state"><span class="spinner"></span>Opening the source…</div>
{/if}
